import React from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import palette from "src/theme/palette";

const Card = styled(Stack)({
  backgroundColor: palette.system[0],
  border: "1px solid",
  borderColor: palette.grey[200],
  borderRadius: 8,
  overflow: "hidden"
});

const CardHeader = styled(Stack)({
  height: 64,
  padding: "16px 24px",
  justifyContent: "center"
});

const IconBox = styled(Stack)({
  width: 40,
  height: 40,
  borderRadius: 8,
  backgroundColor: palette.grey[100],
  alignItems: "center",
  justifyContent: "center"
});

const TeamMember = ({ name, role }) => (
  <Stack direction="row" alignItems="center" gap="10px" flex={1}>
    <IconBox>
      <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: palette.text[700] }} />
    </IconBox>
    <Stack>
      <Typography variant="subtitle2" color="text.800">
        {name}
      </Typography>
      <Typography variant="body2" color="text.700">
        {role}
      </Typography>
    </Stack>
  </Stack>
);

const AccountTeamSection = ({ teamMembers }) => {
  if (!teamMembers?.length) return null;

  return (
    <Card data-testid="account-team-section">
      <CardHeader>
        <Typography variant="h6">Account team</Typography>
      </CardHeader>
      <Divider />
      <Stack direction="row" gap={3} sx={{ p: 3 }}>
        {teamMembers.map((member) => (
          <TeamMember key={member.role} name={member.name} role={member.role} />
        ))}
      </Stack>
    </Card>
  );
};

export default AccountTeamSection;
